import RealizarPedido from "./pages/RealizarPedido";
import Navbar from "./components/Navbar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PedidoForm from "./pages/PedidoForm";
import Footer from "./components/Footer/Footer";
import PedidoResumen from "./pages/PedidoResumen";
import RollPerson from "./pages/RollPerson";
import ScrollToTop from "./components/Utils/ScrollToTop";
import ImagePrefetcher from "./components/Utils/ImagePrefetcher";
import "./index.css"; // Asegurate de importar tu CSS aquí
import SocialFixed from "./components/SocialFixed";
import EtiquetaEstadoSucursal from "./components/EtiquetaEstadoSucursal";


const App = () => {
  return (
    <BrowserRouter>
      {/* Fondo global */}
      <div className="fondo" />

      <ImagePrefetcher />
      <ScrollToTop />
      <Navbar />
      <SocialFixed />
      <EtiquetaEstadoSucursal />
      
      <Routes>
        <Route path="/" element={<RealizarPedido />} />
        <Route path="/rollperson" element={<RollPerson />} />
        <Route path="/form" element={<PedidoForm />} />
        <Route path="/resumen" element={<PedidoResumen />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
};

export default App;
